/**
 * Cumple Sprint 14 — Cliente API para `/api/v1/users` (público auth).
 */
import { apiRequest } from './client.js';

export interface AssignableUser {
  id: string;
  email: string;
  role: 'auditor' | 'admin';
}

export const usersApi = {
  assignable: () => apiRequest<{ users: AssignableUser[] }>('/api/v1/users/assignable'),
};
